'use client'
import styles from './Cookie.module.scss'
import { useMemo, useEffect, useState } from 'react'
import { usePathname } from 'next/navigation'
import { useTranslation } from 'react-i18next'
import Image from 'next/image'
import { useLocalStorage } from 'usehooks-ts'

const ALT_PAGES = [
    'catalog', 'confidential', 'user', 'cookie', 'news', 'event',
    'profile', 'useful-materials', 'vacancy', 'webinar', 'broshure'
]

const YandexMetrika = () => (
    <>
        <script
            dangerouslySetInnerHTML={{
                __html: `
                    (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)};
                    m[i].l=1*new Date();
                    for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }}
                    k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)})
                    (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

                    ym(11065228, "init", {
                            clickmap:true,
                            trackLinks:true,
                            accurateTrackBounce:true,
                            webvisor:true
                    });
                    `
            }}
        ></script>
        <noscript>
            <div>
                <Image
                    src='https://mc.yandex.ru/watch/11065228'
                    style={{ position: 'absolute', left: '-9999px' }}
                    alt=''
                />
            </div>
        </noscript>
    </>
)

const Cookie = () => {
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const [rejectCookie, setRejectCookie] = useLocalStorage('rejectCookie', false)
    const { t } = useTranslation()
    const path = usePathname()

    const isAltPage = useMemo(() => ALT_PAGES.some(p => path.includes(p)), [path])

    useEffect(() => {
        const agree = localStorage.getItem('confidential')
        if (!agree) {
            setIsOpen(true)
        }
    }, [])

    if (rejectCookie || !isOpen)
        return (
            <>
                {' '}
                <YandexMetrika />
            </>
        )

    return (
        <>
            {' '}
            <div className={styles.wrapper}>
                <div
                    className={styles.main_cards__items}
                    style={
                        isAltPage
                            ? {
                                  background:
                                      'linear-gradient(54deg, rgba(230, 237, 255, .4) 12.66%, rgba(206, 221, 255, .4) 94.41%)'
                              }
                            : {}
                    }
                >
                    <div className={styles.container}>
                        <p
                            className={styles.main_cards__title}
                            style={
                                isAltPage
                                    ? { color: '#7987AC' }
                                    : {}
                            }
                        >
                            {t('cookie').split(':')[0]}{' '}
                            <a
                                className={styles.main_cards__title}
                                target='_blank'
                                href={'/cookie'}
                                style={
                                    isAltPage
                                        ? { color: '#7987AC', textDecoration: 'underline' }
                                        : { textDecoration: 'underline' }
                                }
                                rel='noreferrer'
                            >
                                {t('cookie').split(':')[1]}
                            </a>
                            {t('cookie').split(':')[2]}
                            <a
                                className={styles.main_cards__title}
                                target='_blank'
                                href={'/about-cookie'}
                                style={
                                    isAltPage
                                        ? { color: '#7987AC', textDecoration: 'unset' }
                                        : { textDecoration: 'underline' }
                                }
                                rel='noreferrer'
                            >
                                {t('cookie').split(':')[3]}
                            </a>
                        </p>

                        <button
                            className={`
                            main__card-button know-more ${styles.know_more} main-about__card-button
                            ${isAltPage ? styles.blue_border : ``}
                            `}
                            onClick={() => {
                                localStorage.setItem('confidential', 'true')
                                setIsOpen(false)
                            }}
                        >
                            <p
                                style={
                                    isAltPage
                                        ? {
                                              color: '#83A3EB',
                                              background: 'unset !important',
                                              backgroundClip: 'unset !important',
                                              WebkitBackgroundClip: 'unset !important',
                                              WebkitTextFillColor: 'unset !important',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              textDecoration: 'unset',
                                              alignItems: 'center'
                                          }
                                        : {
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center'
                                          }
                                }
                            >
                                <span
                                    style={{
                                        fontSize: '15px',
                                        textDecoration: 'unset',
                                        top: '0',
                                        transform: 'none',
                                        opacity: 1,
                                        position: 'static'
                                    }}
                                >
                                    {t('ok')}
                                </span>
                            </p>
                        </button>

                        <button
                            style={{
                                minWidth: 160,
                                cursor: 'pointer',
                                zIndex: 99999999999999,
                                maxHeight: 45,
                                border: '1px solid rgba(60, 49, 137, 0.24)',
                                background:
                                    'linear-gradient(298deg, rgba(143, 104, 241, 0.2) -2.98%, rgba(64, 176, 255, 0.2) 100%)',
                                boxShadow: '-2px 2px 6px 0px rgba(39, 33, 97, 0.4)',
                                color: '#83a3eb',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center'
                            }}
                            className={`
                            main__card-button
                            ${isAltPage ? styles.blue_border : ``}
                            `}
                            onClick={() => {
                                setRejectCookie(true)
                                setIsOpen(false)
                            }}
                        >
                            <p
                                style={
                                    isAltPage
                                        ? {
                                              maxWidth: 160,
                                              maxHeight: 45,
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center'
                                          }
                                        : {
                                              maxWidth: 160,
                                              maxHeight: 45,

                                              color: '#83a3eb',
                                              display: 'flex',
                                              justifyContent: 'center',
                                              alignItems: 'center'
                                          }
                                }
                            >
                                <span
                                    style={{
                                        fontSize: '15px',
                                        textDecoration: 'unset',
                                        color: '#83a3eb',
                                        top: '0',
                                        transform: 'none',
                                        opacity: 1,
                                        position: 'static'
                                    }}
                                >
                                    {t('reject')}
                                </span>
                            </p>
                        </button>
                    </div>
                </div>
            </div>
            <YandexMetrika />
        </>
    )
}

export default Cookie
